import API_BASE_URL from '../services/config/api';

const getApiOrigin = () => {
	try {
		return new URL(API_BASE_URL).origin;
	} catch (_error) {
		return '';
	}
};

const isSubhueHost = (hostname = '') =>
	String(hostname).toLowerCase().endsWith('subhue.org');

const withCacheBuster = (url) => {
	const separator = url.includes('?') ? '&' : '?';
	return `${url}${separator}t=${new Date().getTime()}`;
};

export const normalizeBlogImageUrl = (image) => {
	if (!image) return null;

	const rawImage = String(image).trim();
	if (!rawImage) return null;

	const apiOrigin = getApiOrigin();

	try {
		const imageUrl = new URL(rawImage, apiOrigin || window.location.origin);
		const apiUrl = apiOrigin ? new URL(apiOrigin) : null;

		if (
			apiUrl &&
			isSubhueHost(imageUrl.hostname) &&
			isSubhueHost(apiUrl.hostname) &&
			imageUrl.hostname !== apiUrl.hostname
		) {
			imageUrl.protocol = apiUrl.protocol;
			imageUrl.host = apiUrl.host;
		}

		return withCacheBuster(imageUrl.toString());
	} catch (_error) {
		return withCacheBuster(rawImage);
	}
};
